import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

// Features
const TemplateListPage = Loadable(
  lazy(() => import('src/pages/features/templates/TemplateListPage'))
);
const TemplateDetailPage = Loadable(
  lazy(() => import('src/pages/features/templates/TemplateDetailPage'))
);
const ServiceListPage = Loadable(
  lazy(() => import('src/pages/features/services/ServiceListPage'))
);
const ServiceDetailPage = Loadable(
  lazy(() => import('src/pages/features/services/ServiceDetailPage'))
);
const SnippetListPage = Loadable(
  lazy(() => import('src/pages/features/snippets/SnippetListPage'))
);
const SnippetDetailPage = Loadable(
  lazy(() => import('src/pages/features/snippets/SnippetDetailPage'))
);
const AppsMarketplaceListPage = Loadable(
  lazy(() =>
    import('src/pages/features/appsMarketplace/AppsMarketplaceListPage')
  )
);
const AppsMarketplaceDetailPage = Loadable(
  lazy(() =>
    import('src/pages/features/appsMarketplace/AppsMarketplaceDetailPage')
  )
);
const MobileAppListPage = Loadable(
  lazy(() => import('src/pages/features/mobileApps/MobileAppListPage'))
);
const MobileAppDetailPage = Loadable(
  lazy(() => import('src/pages/features/mobileApps/MobileAppDetailPage'))
);

const routes = [
  {
    path: 'features/bootstrap-templates',
    element: <TemplateListPage />
  },
  {
    path: 'features/bootstrap-templates/:id',
    element: <TemplateDetailPage />
  },
  {
    path: 'features/apps-marketplace',
    element: <AppsMarketplaceListPage />
  },
  {
    path: 'features/apps-marketplace/:id',
    element: <AppsMarketplaceDetailPage />
  },
  { path: 'features/services', element: <ServiceListPage /> },
  {
    path: 'features/services/:id',
    element: <ServiceDetailPage />
  },
  {
    path: 'features/mobile-apps',
    element: <MobileAppListPage />
  },
  {
    path: 'features/mobile-apps/:id',
    element: <MobileAppDetailPage />
  },
  {
    path: 'features/snippets',
    element: <SnippetListPage />
  },
  {
    path: 'features/snippets/:id',
    element: <SnippetDetailPage />
  }
];

export default routes;
